let bqjUrl = ""; //这里是一个默认的url，可以没有
let svipUrl =""; //
switch (process.env.NODE_ENV) {
    case 'pre':
        bqjUrl = "https://previpback.bqj.cn" //这里是本地的请求
        // bqjUrl = "http://192.168.30.30:18888"
        svipUrl = "https://tsmars.bqj.cn/"
        break
    case 'test':
        bqjUrl = "https://tsbqjback.bqj.cn" // 测试环境
        svipUrl = "https://tsmars.bqj.cn/"
        break
    case 'production':
        bqjUrl = "https://vipback.bqj.cn" //生产环境
        svipUrl =  "https://svip.bqj.cn/"
        break

    default:
        //bqjUrl = "https://previpback.bqj.cn" // 测试环境
        bqjUrl = "http://127.0.0.1:18889"
        svipUrl = "https://tsmars.bqj.cn/"
        break
}

export{
    bqjUrl,
    svipUrl
};
